import classNames from "classnames";
import React, { HTMLInputAutoCompleteAttribute, useState } from "react";
import ControlledSelect from "./ControlledInputs/ControlledSelect";

interface Props {
  autoComplete?: HTMLInputAutoCompleteAttribute;
  id: string;
  label?: string;
  onChange?: (value: string) => void;
  options: {
    title: string;
    value: string;
  }[];
  additionalClassName?: string;
  value?: string | null;
}

const Select = (props: Props) => {
  const {
    onChange,
    options,
    additionalClassName = "",
    value: propValue,
    ...selectProps
  } = props;

  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState(options[0]?.value ?? "");

  const onSelectionChanged = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setValue(e.target.value);

    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <ControlledSelect
      {...selectProps}
      additionalClassName={classNames(additionalClassName ?? "", "mb-6 lg:mb-10")}
      focused={focused}
      onBlur={() => setFocused(false)}
      onChange={onSelectionChanged}
      onFocus={() => setFocused(true)}
      options={options}
      value={propValue ?? value}
      isControlled={!!propValue}
    />
  );
};

export default Select;
